export function riskPerUnit(direction, entry, stopLoss) {
    const risk = direction === "LONG" ? entry - stopLoss : stopLoss - entry;
    if (!Number.isFinite(risk) || risk <= 0) {
        throw new Error("Stop loss must define positive risk from entry.");
    }
    return risk;
}
export function targetFromR(entry, stopLoss, direction, rMultiple) {
    const risk = riskPerUnit(direction, entry, stopLoss);
    return direction === "LONG" ? entry + risk * rMultiple : entry - risk * rMultiple;
}
export function riskReward(entry, stopLoss, target, direction) {
    const risk = riskPerUnit(direction, entry, stopLoss);
    const reward = direction === "LONG" ? target - entry : entry - target;
    if (!Number.isFinite(reward) || reward <= 0)
        return 0;
    return Number((reward / risk).toFixed(2));
}
export function assertNoStopWidening(direction, currentStop, proposedStop) {
    const widens = direction === "LONG" ? proposedStop < currentStop : proposedStop > currentStop;
    if (widens) {
        throw new Error("Stop-loss widening is not allowed after entry.");
    }
    return proposedStop;
}
export function distancePercent(price, level) {
    if (!price)
        return 0;
    return Number((((level - price) / price) * 100).toFixed(2));
}
export function positionSizeForRisk(equity, entry, stopLoss, riskFraction = 0.02) {
    if (equity <= 0)
        throw new Error("Equity must be positive.");
    const perUnitRisk = Math.abs(entry - stopLoss);
    if (!Number.isFinite(perUnitRisk) || perUnitRisk <= 0)
        throw new Error("Entry and stop must define positive risk.");
    return Number(((equity * riskFraction) / perUnitRisk).toFixed(4));
}
export function totalOpenRisk(trades) {
    return Number(trades.reduce((sum, trade) => sum + Math.abs(trade.entry - trade.stopLoss) * trade.quantity, 0).toFixed(2));
}
export function portfolioCapStatus(openPositions, maxOpenPositions = 3) {
    return {
        openPositions,
        maxOpenPositions,
        canEnterNewPosition: openPositions < maxOpenPositions,
        warning: openPositions >= maxOpenPositions
            ? "Portfolio cap reached: max 3 concurrent open positions for correlated v1 watchlist."
            : openPositions === maxOpenPositions - 1
                ? "One slot remains before the 3-position portfolio risk cap."
                : null
    };
}
